import { render, staticRenderFns } from "./DetailsInformationFundPrice.vue?vue&type=template&id=77f376e3&"
import script from "./DetailsInformationFundPrice.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationFundPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports